/* tslint:disable */

/**
 */
export class NewUser {
    username?: string;
    email?: string;
    password?: string;
    confirmpassword?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/new-user.ts